
(function () {
  'use strict';

  const SELECTORS = {
    switcher: '.jg-price-switcher',
    nativePrice: '[data-jg-native-price]',
    discountPrice: '[data-jg-discount-price]',
    fromPrice: '[data-jg-from-price]',
    tierLabel: '[data-jg-tier-label]',
    msrp: '[data-jg-msrp]',

    widget: '.discounty-volume-discount-widget',
    rows: '.discounty-volume-discount-widget__table tbody tr'
  };

  /**
   * 读取 Discounty 最低阶梯价格
   */
  function getLowestTier(widget) {
    if (!widget) return null;

    const rows = widget.querySelectorAll(SELECTORS.rows);
    let lowest = null;

    rows.forEach(function (row) {
      const buyCell = row.querySelector(
        '[data-column-id="buy"]'
      );

      const priceCell = row.querySelector(
        'td[data-column-id^="price-each"]'
      );

      if (!buyCell || !priceCell) return;

      const priceText = priceCell.textContent.trim();

      // 提取价格，例如 $9.74、€9.74
      const match = priceText.match(/[\d,]+(?:\.\d+)?/);

      if (!match) return;

      const value = Number(
        match[0].replace(/,/g, '')
      );

      if (!Number.isFinite(value) || value <= 0) return;

      if (!lowest || value < lowest.value) {
        lowest = {
          value: value,
          price: priceText,
          quantity: buyCell.textContent.trim()
        };
      }
    });

    return lowest;
  }

  /**
   * 获取 Shopify 当前变体正常售价
   *
   * 有 Shopify 自身促销价时读取促销价；
   * 没有促销价时读取正常售价。
   * 不读取 compare_at_price。
   */
  function getOriginalPrice(nativePrice) {
    if (!nativePrice) return '';

    const salePrice = nativePrice.querySelector(
      '.price__sale .price-item--sale'
    );

    if (salePrice && salePrice.textContent.trim()) {
      return salePrice.textContent.trim();
    }

    const regularPrice = nativePrice.querySelector(
      '.price__regular .price-item--regular'
    );

    if (regularPrice && regularPrice.textContent.trim()) {
      return regularPrice.textContent.trim();
    }

    const fallbackPrice = nativePrice.querySelector(
      '.price-item--regular, .price-item--sale'
    );

    return fallbackPrice
      ? fallbackPrice.textContent.trim()
      : '';
  }

  /**
   * 查找当前产品对应的 Discounty 表格
   */
  function findDiscountWidget(container) {
    const productInfo = container.closest('product-info');

    if (productInfo) {
      const widget = productInfo.querySelector(
        SELECTORS.widget
      );

      if (widget) return widget;
    }

    const section = container.closest('.shopify-section');

    if (section) {
      return section.querySelector(SELECTORS.widget);
    }

    return null;
  }

  /**
   * 更新单个产品价格
   */
  function updatePrice(container) {
    const nativePrice = container.querySelector(
      SELECTORS.nativePrice
    );

    const discountPrice = container.querySelector(
      SELECTORS.discountPrice
    );

    const fromPrice = container.querySelector(
      SELECTORS.fromPrice
    );

    const tierLabel = container.querySelector(
      SELECTORS.tierLabel
    );

    const msrp = container.querySelector(
      SELECTORS.msrp
    );

    if (!nativePrice || !discountPrice) return;

    const widget = findDiscountWidget(container);

    // 没有 Discounty 活动表格，显示 Dawn 原生价格
    if (!widget) {
      nativePrice.hidden = false;
      discountPrice.hidden = true;
      return;
    }

    // 获取最低折扣阶梯
    const tier = getLowestTier(widget);

    // 没有有效折扣价格，显示 Dawn 原生价格
    if (!tier) {
      nativePrice.hidden = false;
      discountPrice.hidden = true;
      return;
    }

    // 第一行：From $9.74
    if (fromPrice) {
      fromPrice.textContent = 'From ' + tier.price;
    }

    // 第一行右侧：Lowest price for 10+ rolls
    if (tierLabel) {
      tierLabel.textContent = tier.quantity;
    }

    // 第二行：MSRP
    const originalPrice = getOriginalPrice(nativePrice);

    if (msrp && originalPrice) {
      msrp.textContent = originalPrice;
    }

    // 显示 Discounty 价格，隐藏 Dawn 原生价格
    nativePrice.hidden = true;
    discountPrice.hidden = false;
  }

  /**
   * 更新页面全部价格区域
   */
  function updateAllPrices() {
    document.querySelectorAll(SELECTORS.switcher).forEach(
      function (container) {
        updatePrice(container);
      }
    );
  }

  /**
   * 合并连续 DOM 更新，避免重复执行
   */
  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateAllPrices();
    });
  }

  /**
   * 初始化
   */
  function init() {
    updateAllPrices();

    // 监听 Discounty 动态加载和 Dawn 价格更新
    const observer = new MutationObserver(function () {
      scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // 监听 Shopify 变体切换
    document.addEventListener('change', function (event) {
      if (
        event.target.matches(
          'variant-selects select, variant-radios input, [name^="options"]'
        )
      ) {
        setTimeout(scheduleUpdate, 300);
        setTimeout(scheduleUpdate, 800);
        setTimeout(scheduleUpdate, 1500);
      }
    });

    // 监听 Shopify 主题区块重新加载
    document.addEventListener(
      'shopify:section:load',
      scheduleUpdate
    );

    // 监听页面重新显示
    window.addEventListener(
      'pageshow',
      scheduleUpdate
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
